// removed by extract-text-webpack-plugin
module.exports = {"login":"antd-pro-login-login","tabs":"antd-pro-login-tabs","prefixIcon":"antd-pro-login-prefixIcon","getCaptcha":"antd-pro-login-getCaptcha","submit":"antd-pro-login-submit"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/src/components/Login/index.less
// module id = 132
// module chunks = 0